<template>
    <div
        v-if="isVisible"
        class="returnability-promo returnability-promo--wasabi-frame"
        role="article"
        :aria-label="title"
    >
        <span class="returnability-promo__tag">Реклама</span>
        <div class="returnability-promo__motif" aria-hidden="true"></div>
        <div class="returnability-promo__ico" aria-hidden="true">⚙️</div>
        <div class="returnability-promo__body">
            <span class="returnability-promo__badge">Маркетплейс</span>
            <div class="returnability-promo__title">{{ title }}</div>
            <div class="returnability-promo__desc">{{ description }}</div>
        </div>
        <button type="button" class="returnability-promo__btn" @click="goToMarketplace">
            Узнать подробнее
        </button>
    </div>
</template>

<script>
import config from '@root/config'
import { checkIntegrationInstalled } from '@/api/marketplace'

export default {
    name: 'ReturnabilityPromoBanner',
    props: {
        projectId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: 'Удержание 75% — можно выше с экспертной настройкой',
        },
        description: {
            type: String,
            default:
                'Эксперты Data Heroes настроят сегменты и цепочки автокасаний, чтобы клиенты возвращались. Рост выручки гарантирован.',
        },
    },
    data: () => ({
        isVisible: false,
    }),
    async mounted() {
        const marketplaceId = config.marketplaceModulesIds[config.buildType].crmSettings
        if (!this.projectId || !marketplaceId) return

        const isInstalled = await checkIntegrationInstalled(this.projectId, marketplaceId)
        this.isVisible = !isInstalled
    },
    methods: {
        goToMarketplace() {
            const marketplaceId = config.marketplaceModulesIds[config.buildType].crmSettings
            if (!this.projectId || !marketplaceId) return
            const targetPath = `/project/${this.projectId}/marketplace/integration/${marketplaceId}`
            const { href } = this.$router.resolve(targetPath)
            window.open(href, '_blank', 'noopener,noreferrer')
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.returnability-promo
    position: relative
    display: flex
    align-items: center
    gap: 20px
    padding: 18px 24px
    border-radius: 13px
    overflow: hidden
    background: #fff
    border: 1px solid $border-new
    font-family: $font-family-base
    transition: transform .18s ease

    &:hover
        transform: translateY(-1px)

.returnability-promo--wasabi-frame
    border: 2.5px solid $pop-new
    box-shadow: 0 4px 18px rgba($pop-new, .18)

.returnability-promo__tag
    position: absolute
    top: 10px
    right: 14px
    z-index: 4
    font-size: 8px
    font-weight: 800
    letter-spacing: .12em
    text-transform: uppercase
    color: rgba($dark-new, .35)

.returnability-promo__motif
    position: absolute
    inset: 0
    z-index: 1
    pointer-events: none
    background-image: radial-gradient(rgba($main-new, .13) 1.5px, transparent 1.5px)
    background-size: 18px 18px
    -webkit-mask-image: linear-gradient(105deg, transparent 45%, #000 100%)
    mask-image: linear-gradient(105deg, transparent 45%, #000 100%)

.returnability-promo__ico
    width: 54px
    height: 54px
    border-radius: 14px
    display: flex
    align-items: center
    justify-content: center
    font-size: 25px
    flex-shrink: 0
    position: relative
    z-index: 3
    background: $dark-new
    color: $pop-new

.returnability-promo__body
    flex: 1
    min-width: 0
    position: relative
    z-index: 3

.returnability-promo__badge
    display: inline-flex
    font-size: 9.5px
    font-weight: 800
    letter-spacing: .08em
    text-transform: uppercase
    padding: 3px 10px
    border-radius: 999px
    margin-bottom: 7px
    background: $bcg-card-new
    color: $main-new

.returnability-promo__title
    font-size: 18px
    font-weight: 900
    letter-spacing: -.02em
    line-height: 1.18
    margin-bottom: 5px
    color: $dark-new

.returnability-promo__desc
    font-size: 12.5px
    font-weight: 500
    line-height: 1.45
    max-width: 600px
    color: rgba($dark-new, .56)

.returnability-promo__btn
    flex-shrink: 0
    position: relative
    z-index: 3
    border: none
    border-radius: 9px
    cursor: pointer
    font-family: $font-family-base
    font-weight: 800
    font-size: 13px
    padding: 12px 22px
    white-space: nowrap
    background: $pop-new
    color: #1A1800
    box-shadow: 0 2px 12px rgba($pop-new, .45)

    &:hover
        filter: brightness(.96)
        transform: translateY(-1px)

@media (max-width: 820px)
    .returnability-promo__desc
        display: none
</style>
